import { Button, Form, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UsersGroup } from "../interfaces/UsersGroup";
import UserSelector from "../elements/UserSelector";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Overlay } from "../elements/Overlay";

export interface UsersGroupEditProps {
    usersGroup: UsersGroup;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function UsersGroupEdit(props: UsersGroupEditProps) {
    const { t } = useTranslation();

    const navigate = useNavigate();
    
    const [usersSelected, setUsersSelected] = useState<any[]>(props.usersGroup.users);
    
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        let error = false;
        let error_messages: string[] = [];
        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const newUsersGroup = Object.assign({}, props.usersGroup);
            newUsersGroup.name = event.target.name.value;
            newUsersGroup.description = event.target.description.value;
            newUsersGroup.users = usersSelected;
            const requestOptionsPost = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newUsersGroup)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/users-groups/' + props.usersGroup._id, requestOptionsPost)
                .then(response => {
                    if (response.status !== 200) {
                        navigate('/');
                    }
                    return response.json();
                })
                .then(data => {
                    props.submitCallback(newUsersGroup);                    
                });
        }
    }

    return(
        <Overlay
            title={ t("Edit group") }
            onClose={ handleClose }
            className="admin-edit-org-container"
        >
            <div className="org-form-container">
                <Form onSubmit={ handleSubmit }>
                    <FormGroup className="name" controlId="name">
                        <Form.Label aria-required={ true }>{ t("Name") }</Form.Label>
                        <Form.Control type="text" required={ true } defaultValue={ props.usersGroup.name }
                            placeholder={ t("Enter a name") } />
                    </FormGroup>
                    <Form.Group className="field field-description">
                        <FormLabel htmlFor="description">{ t("Description") }</FormLabel>
                        <FormControl as="textarea" defaultValue={ props.usersGroup.description } name="description" />
                    </Form.Group>
                    <UserSelector users={ props.usersGroup.users } usersCallback={ setUsersSelected } />
                    <div className="actions">
                        <Button type="submit" variant="primary">{ t("Save") }</Button>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}